/**
 * Custom Collection Page JavaScript - Shopify Dawn Theme
 * Handles live interactive filtering, mobile flyout drawer, price slider, sort redirect, Ajax cart, and wishlist.
 */
document.addEventListener('DOMContentLoaded', () => {
  // 1. Dynamic Wishlist with LocalStorage Persistence & Header Sync
  const wishlistButtons = document.querySelectorAll('.card-wishlist-trigger');
  wishlistButtons.forEach(btn => {
    const card = btn.closest('.collection-product-card, .product-card, .card-wrapper') || btn.closest('.card');
    
    const pTitle = btn.dataset.title || (card ? card.querySelector('.card-product-title, .card__heading')?.textContent.trim() : 'Chikankari Kurta Set');
    const pPrice = btn.dataset.price || (card ? card.querySelector('.card-product-price, .price')?.textContent.trim() : '');
    const pImg = btn.dataset.image || (card ? card.querySelector('img')?.src : '');
    const pUrl = btn.dataset.url || (card ? (card.getAttribute('href') || card.querySelector('a')?.getAttribute('href')) : '#');
    const vId = btn.dataset.variantId || (card ? card.querySelector('.card-quick-add-bag')?.getAttribute('data-variant-id') : '');
    const itemId = vId || pTitle;

    let list = (typeof getStoredWishlist === 'function') ? getStoredWishlist() : JSON.parse(localStorage.getItem('winningkart_wishlist') || '[]');
    const isSaved = list.some(item => {
      if (!item) return false;
      const id = typeof item === 'string' ? item : (item.id || item.title || item.variantId);
      return id === itemId || id === pTitle;
    });

    if (isSaved) {
      btn.classList.add('active');
      btn.innerHTML = '♥';
    } else {
      btn.classList.remove('active');
      btn.innerHTML = '♡';
    }

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      let currentList = (typeof getStoredWishlist === 'function') ? getStoredWishlist() : JSON.parse(localStorage.getItem('winningkart_wishlist') || '[]');
      const currentlySaved = currentList.some(item => {
        if (!item) return false;
        const id = typeof item === 'string' ? item : (item.id || item.title || item.variantId);
        return id === itemId || id === pTitle;
      });

      if (currentlySaved) {
        currentList = currentList.filter(item => {
          if (!item) return false;
          const id = typeof item === 'string' ? item : (item.id || item.title || item.variantId);
          return id !== itemId && id !== pTitle;
        });
        btn.classList.remove('active');
        btn.innerHTML = '♡';
      } else {
        currentList.push({
          id: itemId,
          title: pTitle,
          price: pPrice,
          image: pImg,
          url: pUrl,
          variantId: vId
        });
        btn.classList.add('active');
        btn.innerHTML = '♥';
      }

      if (typeof saveStoredWishlist === 'function') {
        saveStoredWishlist(currentList);
      } else {
        localStorage.setItem('winningkart_wishlist', JSON.stringify(currentList));
      }

      if (typeof updateWishlistUI === 'function') {
        updateWishlistUI();
      }
    });
  });

  // 2. Real Shopify Dynamic Add to Cart (/cart/add.js)
  const quickAddBags = document.querySelectorAll('.card-quick-add-bag');
  quickAddBags.forEach(bag => {
    bag.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const card = bag.closest('.collection-product-card');
      const productUrl = card ? card.getAttribute('href') : null;
      const variantId = bag.getAttribute('data-variant-id');
      const originalHtml = bag.innerHTML;

      bag.innerHTML = '⌛';
      bag.style.backgroundColor = '#5C1D24';
      bag.style.color = '#ffffff';

      const resetBag = () => {
        setTimeout(() => {
          bag.innerHTML = originalHtml;
          bag.style.backgroundColor = '';
          bag.style.color = '';
        }, 1500);
      };

      if (variantId && parseInt(variantId, 10)) {
        const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        const addUrl = rootPath + 'cart/add.js';
        const cartUrl = rootPath + 'cart';

        fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: 1
          })
        })
        .then(async (res) => {
          const data = await res.json().catch(() => ({}));
          if (res.ok && !data.errors && !data.status) {
            bag.innerHTML = '✓';

            // Try updating header cart badge if present
            fetch(rootPath + 'cart.js')
              .then(r => r.json())
              .then(cartData => {
                const countElements = document.querySelectorAll('.site-header__cart-count, .cart-count-bubble, [data-cart-count]');
                countElements.forEach(el => {
                  el.textContent = cartData.item_count;
                  el.style.display = cartData.item_count > 0 ? '' : 'none';
                });
              }).catch(() => {});

            // Dispatch cart refresh event for Shopify Dawn themes
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: data } }));

            setTimeout(() => {
              window.location.href = cartUrl;
            }, 400);
          } else {
            console.warn('Could not add to cart via API:', data);
            bag.innerHTML = '✓';
            if (productUrl && productUrl !== '#') {
              window.location.href = productUrl;
            } else {
              window.location.href = cartUrl;
            }
          }
        })
        .catch(err => {
          console.error('Cart add fetch error:', err);
          bag.innerHTML = '✓';
          if (productUrl && productUrl !== '#') {
            window.location.href = productUrl;
          } else {
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
          }
        });
      } else if (productUrl && productUrl !== '#') {
        window.location.href = productUrl;
      } else {
        setTimeout(() => {
          bag.innerHTML = '✓';
          resetBag();
        }, 400);
      }
    });
  });

  // 3. Dynamic Sort Dropdown Change
  const sortBySelect = document.getElementById('SortBy');
  if (sortBySelect) {
    sortBySelect.addEventListener('change', (e) => {
      const value = e.target.value;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.href;
    });
  }

  // 4. Instant Live Product Filtering Logic
  const productCards = document.querySelectorAll('.collection-product-card');
  const resultsCount = document.querySelector('.collection-results-count');

  const filterCheckboxes = document.querySelectorAll('.collection-sidebar-filters input[type="checkbox"]');
  const filterColorSwatches = document.querySelectorAll('.filter-color-swatch');
  const priceSlider = document.getElementById('PriceRangeSlider');
  const maxPriceInput = document.getElementById('MaxPriceInput');

  function runLiveFilter() {
    let visibleCount = 0;
    const totalCount = productCards.length;

    // Selected values
    const checkedCategories = [];
    const checkedSizes = [];
    const checkedColors = [];
    const checkedFabrics = [];
    const checkedOccasions = [];
    const checkedEmbroideries = [];

    document.querySelectorAll('.filter-group-block').forEach((group) => {
      const titleEl = group.querySelector('.filter-group-title');
      if (!titleEl) return;
      const title = titleEl.textContent.trim().toUpperCase();

      const checkedInputs = group.querySelectorAll('input[type="checkbox"]:checked');
      checkedInputs.forEach(input => {
        const val = (input.value || input.parentNode.textContent || '').trim().toLowerCase();
        if (title.includes('CATEGOR')) checkedCategories.push(val);
        else if (title.includes('SIZE')) checkedSizes.push(val);
        else if (title.includes('FABRIC')) checkedFabrics.push(val);
        else if (title.includes('OCCASION')) checkedOccasions.push(val);
        else if (title.includes('EMBROIDERY')) checkedEmbroideries.push(val);
      });

      if (title.includes('COLOR')) {
        const activeSwatches = group.querySelectorAll('.filter-color-swatch.active');
        activeSwatches.forEach(sw => {
          const colorName = (sw.getAttribute('title') || '').trim().toLowerCase();
          if (colorName) checkedColors.push(colorName);
        });
      }
    });

    let maxPrice = Infinity;
    if (priceSlider && priceSlider.value) {
      maxPrice = parseFloat(priceSlider.value);
      if (maxPriceInput) {
        maxPriceInput.value = '₹' + parseInt(maxPrice).toLocaleString('en-IN');
      }
    }

    productCards.forEach(card => {
      const pTitle = (card.querySelector('.card-product-title')?.textContent || '').toLowerCase();
      const pType = (card.getAttribute('data-type') || '').toLowerCase();
      const pTags = (card.getAttribute('data-tags') || '').toLowerCase();
      const pPrice = parseFloat(card.getAttribute('data-price') || '0');
      const pSizes = (card.getAttribute('data-sizes') || '').toLowerCase();
      const pColors = (card.getAttribute('data-colors') || '').toLowerCase();

      let isMatch = true;

      if (maxPrice < 6999 && pPrice > 0 && pPrice > maxPrice) {
        isMatch = false;
      }

      if (isMatch && checkedCategories.length > 0) {
        const catMatch = checkedCategories.some(cat => 
          cat.includes('all') || pType.includes(cat) || pTitle.includes(cat) || pTags.includes(cat)
        );
        if (!catMatch) isMatch = false;
      }

      if (isMatch && checkedSizes.length > 0) {
        const sizeMatch = checkedSizes.some(sz => pSizes.includes(sz) || pTags.includes(sz) || pTitle.includes(sz));
        if (!sizeMatch) isMatch = false;
      }

      if (isMatch && checkedColors.length > 0) {
        const colorMatch = checkedColors.some(col => pColors.includes(col) || pTags.includes(col) || pTitle.includes(col));
        if (!colorMatch) isMatch = false;
      }

      if (isMatch && checkedFabrics.length > 0) {
        const fabricMatch = checkedFabrics.some(fab => pTags.includes(fab) || pTitle.includes(fab));
        if (!fabricMatch) isMatch = false;
      }

      if (isMatch && checkedOccasions.length > 0) {
        const occasionMatch = checkedOccasions.some(occ => pTags.includes(occ) || pTitle.includes(occ));
        if (!occasionMatch) isMatch = false;
      }

      if (isMatch && checkedEmbroideries.length > 0) {
        const embMatch = checkedEmbroideries.some(emb => pTags.includes(emb) || pTitle.includes(emb));
        if (!embMatch) isMatch = false;
      }

      if (isMatch) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    if (resultsCount) {
      resultsCount.textContent = `Showing 1-${visibleCount} of ${totalCount} products`;
    }
  }

  filterCheckboxes.forEach(cb => {
    cb.addEventListener('change', runLiveFilter);
  });

  filterColorSwatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      swatch.classList.toggle('active');
      runLiveFilter();
    });
  });

  if (priceSlider) {
    priceSlider.addEventListener('input', runLiveFilter);
  }

  // 5. Clear All Filters Button
  const clearAllBtn = document.getElementById('FilterClearAll');
  if (clearAllBtn) {
    clearAllBtn.addEventListener('click', (e) => {
      e.preventDefault();
      filterCheckboxes.forEach(cb => cb.checked = false);
      filterColorSwatches.forEach(sw => sw.classList.remove('active'));
      if (priceSlider) {
        priceSlider.value = priceSlider.max;
      }
      runLiveFilter();
    });
  }

  // 6. Mobile Flyout Filter Drawer Open / Close
  const openBtn = document.getElementById('MobileFilterOpenBtn');
  const closeBtn = document.getElementById('MobileFilterCloseBtn');
  const backdrop = document.getElementById('MobileFilterBackdrop');
  const drawer = document.getElementById('CollectionSidebarDrawer');

  function openMobileFilter() {
    if (drawer) drawer.classList.add('mobile-active');
    if (backdrop) backdrop.classList.add('mobile-active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileFilter() {
    if (drawer) drawer.classList.remove('mobile-active');
    if (backdrop) backdrop.classList.remove('mobile-active');
    document.body.style.overflow = '';
  }

  if (openBtn) openBtn.addEventListener('click', openMobileFilter);
  if (closeBtn) closeBtn.addEventListener('click', closeMobileFilter);
  if (backdrop) backdrop.addEventListener('click', closeMobileFilter);
});
